import { render, staticRenderFns } from "./patientlist.vue?vue&type=template&id=6717fe17&scoped=true"
import script from "./patientlist.vue?vue&type=script&lang=js"
export * from "./patientlist.vue?vue&type=script&lang=js"
import style0 from "./patientlist.vue?vue&type=style&index=0&id=6717fe17&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717fe17",
  null
  
)

export default component.exports